import { OrgHomeScreenProps } from "../OrgHomeNavigation";
import React from "react";
import { LazyQueryNetworkBoundrary } from "../../../components/mobile/QueryNetworkBoundrary";

import { useWorkspaceId } from "../workspaceId";
import { WorkspaceProductsSearch } from "./WorkspaceProductsSearch";
import { View } from "react-native";
import { useOrgHomeDetailLayout } from "../useOrgHomeDetailContainerStyle";
function InnerWorkspaceProductsScreen(
  props: OrgHomeScreenProps<"WorkspaceProducts"> & { fetchKey: string }
) {
  const [, setSearchOpen] = React.useState(false);
  const workspaceId = useWorkspaceId();
  const styles = useOrgHomeDetailLayout();
  return (
    <View style={styles.contentContainerStyle}>
      <WorkspaceProductsSearch
        workspaceId={workspaceId}
        onFocus={() => setSearchOpen(true)}
        onBlur={() => setSearchOpen(false)}
        onPressProduct={(productId) => {
          props.navigation.navigate("Product", {
            id: productId,
            type: "id",
            state: "details",
          });
        }}
        isSearching
      />
    </View>
  );
}

export function WorkspaceProductsScreen(
  props: OrgHomeScreenProps<"WorkspaceProducts">
) {
  return (
    <LazyQueryNetworkBoundrary newFetchKeyOnNavigation>
      {(fetchKey: string) => (
        <InnerWorkspaceProductsScreen {...props} fetchKey={fetchKey} />
      )}
    </LazyQueryNetworkBoundrary>
  );
}
